import React, { useCallback, type FC } from 'react'

import { useAtom } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import {
  Flex,
  FormElement,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  Toggle,
} from 'mailup-web-components'
import { useIntl } from 'react-intl'

import {
  changeFilterTypesCallback,
  toggleAllFilterTypesCallback,
} from 'Pages/unifiedFiltersListPage/callbacks/search'
import {
  availFilterTypesAtom,
  filtersQueryAtom,
} from 'Pages/unifiedFiltersListPage/state/state'

const LabelRightComponent: FC = () => {
  const intl = useIntl()
  const [filtersQuery] = useAtom(filtersQueryAtom)

  const handleToggle = useAtomCallback(
    useCallback(toggleAllFilterTypesCallback, []),
  )

  return (
    <Flex justifyContent='end'>
      <Flex gap='8px' alignItems='center'>
        <Toggle
          data-mu-test='toggle-all-filter-types'
          variant='sm'
          checked={filtersQuery.allTypes}
          onChange={handleToggle}
        />
        <span>
          {intl.formatMessage({ id: 'Load.MailupCommon.BtnSelectAll' })}
        </span>
      </Flex>
    </Flex>
  )
}

const InputFilterTypes: FC = () => {
  const intl = useIntl()

  const [availFilterTypes] = useAtom(availFilterTypesAtom)
  const [filtersQuery] = useAtom(filtersQueryAtom)

  const handleChange = useAtomCallback(
    useCallback(changeFilterTypesCallback, []),
  )

  return (
    <FormElement
      label={intl.formatMessage({ id: 'Load.MailupCommon.Type' })}
      LabelRightComponent={LabelRightComponent}
    >
      <Select
        data-mu-test='input-filter-types'
        value={filtersQuery.types}
        options={availFilterTypes}
        multiple
        variant={SELECT_VARIANT_WITH_CHECKBOX}
        onChange={handleChange}
        placeholder={intl.formatMessage({
          id: 'Load.FiltersList.InputTypesPlaceholder',
        })}
        disabled={filtersQuery.allTypes}
        searchable={false}
      />
    </FormElement>
  )
}

export default InputFilterTypes
